import { render, staticRenderFns } from "./customerTraffic.vue?vue&type=template&id=3c6393c8&"
import script from "./customerTraffic.vue?vue&type=script&lang=js&"
export * from "./customerTraffic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports